




































































































































































































































import { Component, Vue, Prop, PropSync, ProvideReactive, Ref, InjectReactive } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import {
  validateMax,
  validateRequired,
  validateInclusion,
  validateType,
} from '@/components/UI/Form/Validations';

import { PaycheckForm as PaycheckFormData } from './PaycheckForm';
import PaycheckEmployeeInfo from '@/components/Paycheck/PaycheckEmployeeInfo.vue';
import PaycheckUnitInfo from '@/components/Paycheck/PaycheckUnitInfo.vue';
import PaycheckInfo from '@/components/Paycheck/PaycheckInfo.vue';
import PaycheckLinesTable from '@/components/Paycheck/PaycheckLinesTable.vue';
import PaycheckPrepayments from '@/components/Paycheck/PaycheckPrepayments.vue';
import SIntegerInput from '@/components/UI/Form/SIntegerInput.vue';

import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_PAYCHECK_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitPaycheckSetting } from '@/queries/__generated__/unitPaycheckSetting';

import SForm from '@/components/UI/Form/SForm.vue';
import TabTitle from '@/utils/tabtitle';
import PaycheckAltinnLog from '@/components/Paycheck/PaycheckAltinnLog.vue';
import DocumentLogo from '@/components/Invoicing/Shared/DocumentLogo.vue';
import Altinn from '@/app/Altinn';
import PermissionService from '@/utils/permission-service';
import Decimal from '@/utils/decimal';
import { taxDeductionMethods } from '@/app/Employee';
import { GQL_workRelationPaycheckSums_workRelation_paycheckSums } from '@/queries/__generated__/workRelationPaycheckSums';

@Component({
  i18n: {
    messages: {
      en: {
        validation: {
          listPriceWarning: "List price is needed to send it to altinn in Amelding",
          carRegistrationWarning: "Registration number in needed to send it to altinn in Amelding",
        },
      },
      nb: {
        validation: {
          listPriceWarning: "Listepris er nødvendig for å kunne sende lønnslippen til altinn i Amelding",
          carRegistrationWarning: "Registreringsnr er nødvendig for å kunne sende lønnslippen til altinn i Amelding",
        },
      },
    },
  },
  components: {
    PaycheckEmployeeInfo,
    PaycheckUnitInfo,
    PaycheckInfo,
    PaycheckWorkRelationInfo: () => import('@/components/Paycheck/PaycheckWorkRelationInfo.vue'),
    PaycheckLinesTable,
    DocumentLogo,
    PaycheckAltinnLog,
    PaycheckPrepayments,
  },
})
export default class PaycheckForm extends Vue {
  @SmartQuery<PaycheckForm, GQL_unitPaycheckSetting>({
    query: UNIT_PAYCHECK_SETTINGS,
    update: data => data.currentUnit.unitSetting.unitPaycheckSetting.startingPaycheckNumber,
  })
  private startingPaycheckNumber!: number;

  @Prop({ type: Object, required: true }) private paycheck!: PaycheckFormData;
  @Ref() private readonly formRef?: SForm;

  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;
  @PropSync('dirty', { type: Boolean, default: false }) private dirtyFormSync!: boolean;

  @InjectReactive() private paycheckSums!: GQL_workRelationPaycheckSums_workRelation_paycheckSums[];

  @ProvideReactive()
  @Prop({ type: Boolean, required: true }) private isLocked!: boolean;

  @ProvideReactive()
  @Prop({ type: Boolean, required: true }) private isPrint!: boolean;

  @ProvideReactive()
  @Prop({ type: Boolean, required: true }) private hasEditPermissions!: boolean;

  @Ref() public paycheckLinesTable?: PaycheckLinesTable;
  @Ref() public paycheckNumberInput?: SIntegerInput;

  private PermissionService = PermissionService;
  private paycheckLinesTotal = new Decimal(0);
  private prepaymentsTotal = new Decimal(0);
  private manualPaycheckNumber = false;
  private taxDeductionMethods = taxDeductionMethods
  private rules: IRules = {};

  private enterManualPaycheckNumber() {
    this.manualPaycheckNumber = true;
    this.$nextTick(() => {
      this.paycheckNumberInput?.focus();
    });
  }

  private cancelManualPaycheckNumber() {
    this.manualPaycheckNumber = false;
    this.paycheck.number = null;
  }

  public resetFormDirty(): void {
    this.formRef && this.formRef.resetDirty();
  }

  public created() {
    TabTitle.setFields({ number: this.paycheck.number });

    this.rules = {
      companyMunicipalityId: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Municipality.municipality') }) } ],
      startDate: [
        { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'startDate') }) },
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      endDate: [
        {
          validation: ({ dataValue, formElements }) => {
            if (!formElements?.startDate?.dataValue || !dataValue) return true;
            return formElements.startDate.dataValue <= dataValue;
          },
          message: i18n => i18n.t('Error.mustBeBefore', {
            beforeField: this.t_attr('Paycheck', 'startDate'),
            afterField: this.t_attr('Paycheck', 'endDate'),
          }),
          triggerBy: [ 'startDate' ],
        },
        { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'endDate') }) },
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      dueDate: [
        { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'dueDate') }) },
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      journalDate: [
        { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'journalDate') }) },
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      paidDate: [
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      employeeBban: [
        {
          validation: validateRequired(),
          if: ({ formElements }) => {
            if (
              !formElements.employeeIban ||
              !formElements.employeeSwift
            ) return true;

            if (
              !formElements.employeeIban.dataValue &&
              !formElements.employeeSwift.dataValue
            ) return true;

            return false;
          },
          message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck','employeeBban') }),
          triggerBy: [ 'employeeIban', 'employeeSwift' ],
          },
        ],
        employeeIban: [
          {
            validation: validateRequired(),
            if: ({ formElements }) => {
              if (
                !formElements.employeeBban ||
                !formElements.employeeSwift
              ) return true;

              if (
                !formElements.employeeBban.dataValue
              ) return true;

              if (
                formElements.employeeSwift.dataValue
              ) return true;

              return false;
            },
            message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'employeeIban') }),
            triggerBy: [ 'employeeBban', 'employeeSwift' ],
          },
        ],
        employeeSwift: [
          {
            validation: validateRequired(),
            if: ({ formElements }) => {
              if (
                !formElements.employeeBban ||
                !formElements.employeeIban
              ) return true;

              if (
                !formElements.employeeBban.dataValue
              ) return true;

              if (
                formElements.employeeIban.dataValue
              ) return true;

              return false;
            },
            message: i18n => i18n.t('Error.required', { field: this.t_attr('Paycheck', 'employeeSwift') }),
            triggerBy: [ 'employeeBban', 'employeeIban' ],
          },
        ],
        paycheckNumber: [
        {
          validation: (args) => validateMax(this.startingPaycheckNumber - 1)(args),
          message: i18n => i18n.t(
            'Paycheck.errorMustBeLowerThanStartNumber',
            { start_number: this.startingPaycheckNumber },
          ),
        },
      ],
      shouldSendToAltinn: [
        { validation: validateInclusion([ true, false ]), message: i18n => i18n.t('Error.yesOrNo') },
      ],
      shouldSendToFakturabank: [
        { validation: validateInclusion([ true, false ]), message: i18n => i18n.t('Error.yesOrNo') },
      ],
      paycheckLines: {
        altinnDescription: [], // Used for triggerBy for paycheckLines.quantity and paycheckLines.sum
        rate: [], // Used for triggerBy for paycheckLines.sum
        quantity: [
          {
            validation: values => {
              if (
                !values.formElements?.paycheckLines?.altinnDescription[values.uid as string]
              ) return true;

              if (
                !Altinn.descriptionsRequiringQuantity.includes(
                  values.formElements.paycheckLines.altinnDescription[values.uid as string].dataValue,
                )
              ) return true;

              const sum = values.formElements?.paycheckLines?.sum?.[values.uid as string]?.dataValue || new Decimal(0);

              if (sum.eq(0)) {
                return true;
              } else {
                return validateRequired()(values);
              }
            },
            message: i18n => i18n.t('Error.required', { field: this.t_attr('PaycheckLine', 'quantity') }),
            triggerBy: [ ({ withSameUID }) => withSameUID('paycheckLines.altinnDescription'), ({ withSameUID }) => withSameUID('paycheckLines.sum') ],
          },
        ],
        sum: [
          {
            validation: ({ dataValue, formElements, uid }) => {
              if (
                !formElements?.paycheckLines?.rate[uid as string] ||
                !formElements?.paycheckLines?.quantity[uid as string]
              ) return true;

              if (
                formElements.paycheckLines.rate[uid as string].dataValue.isZero() &&
                formElements.paycheckLines.quantity[uid as string].dataValue.isZero()
              ) return true;

              return (
                formElements.paycheckLines.quantity[uid as string].dataValue
                  .times(formElements.paycheckLines.rate[uid as string].dataValue)
                  .toDecimalPlaces(2)
                  .eq(dataValue)
              );
            },
            message: i18n => i18n.t('Paycheck.PaycheckLines.sumError'),
            triggerBy: [
              ({ withSameUID }) => withSameUID('paycheckLines.rate'),
              ({ withSameUID }) => withSameUID('paycheckLines.quantity'),
            ],
            type: 'warning',
          },
        ],
        altinnAdditional: {
          carAndBoat: {
            listPriceForCar: [
              { validation: (args) => {
                  // wait for form to initialize
                  if (
                    !args.formElements?.paycheckLines?.altinnDescription ||
                    !args.formElements?.paycheckLines?.altinnDescription[args.uid as string]
                  ) return true;

                  if (args.formElements.paycheckLines.altinnDescription[args.uid as string].dataValue === `bil`) {
                    return validateRequired()(args);
                  }
                  return true;
                },
                message: () => this.$t("validation.listPriceWarning"),
                triggerBy: [ ({ withSameUID }) => withSameUID('paycheckLines.altinnDescription') ],
                type: 'warning',
              },
            ],
            carRegistrationNumber: [
              { validation: (args) => {
                  // wait for form to initialize
                  if (
                    !args.formElements?.paycheckLines?.altinnDescription ||
                    !args.formElements?.paycheckLines?.altinnDescription[args.uid as string]
                  ) return true;

                  if (args.formElements.paycheckLines.altinnDescription[args.uid as string].dataValue === `bil`) {
                    return validateRequired()(args);
                  }
                  return true;
                },
                message: () => this.$t("validation.carRegistrationWarning"),
                triggerBy: [ ({ withSameUID }) => withSameUID('paycheckLines.altinnDescription') ],
                type: 'warning',
              },
            ],
          },
        },
      },
      prepayments: {
        amount: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('PaycheckPrepayment', 'amount') }) } ],
        paymentDate: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('PaycheckPrepayment', 'paymentDate') }) } ],
      },
    };
  }
}
